import axios from "@/lib/axios";

class StatsService {
  constructor() {
    this.api = axios;
  }

  async getCredits() {
    const response = await this.api.get("/merchants/credits");
    return response;
  }

  async getGeneralStats() {
    // Fetch all required data in a single method
    const merchantProductsCount = await this.api.get(
      "/dashboard/merchant-products/count",
    );
    const frequentlyMerchantProducts = await this.api.get(
      "/dashboard/frequently-merchant-products",
    );
    const customersCount = await this.api.get("/dashboard/customers/count");
    const integrationCount = await this.api.get(
      "/dashboard/individual-customer-products/integration/count",
    );
    const credits = await this.getCredits();

    // Return the data directly
    return {
      merchantProductsCount: merchantProductsCount.data,
      frequentlyMerchantProducts: frequentlyMerchantProducts.data,
      customersCount: customersCount.data,
      integrationCount: integrationCount.data,
      credits: credits.data,
    };
  }

  async getSendedWarranties(data) {
    const response = await this.api.get(
      `/dashboard/merchant-products/count-by-specific-time?interval=${data.interval}&temporalUnitEnum=${data.temporalUnitEnum}`,
    );

    return response;
  }

  async getUsageRate(interval) {
    const response = await this.api.get(
      `/dashboard/merchant-products/usage-rate?interval=${interval}`,
    );

    return response;
  }

  async getUnSuccessWarranties(data) {
    const response = await this.api.get(`/merchant-inboxes`, {
      params: { ...data, type: "WARRANTY_ERROR" },
    });

    return response;
  }

  async getInboxList(data) {
    await new Promise((resolve) => setTimeout(resolve, 500));
    const response = await this.api.get(`/merchant-inboxes`, {
      params: data,
    });

    return response;
  }

  async getUnreadInboxCount() {
    const response = await this.api.get(`/merchant-inboxes/unread`);

    return response;
  }

  async markAsRead(id) {
    // body: [id]
    const response = await this.api.put(`/merchant-inboxes/read`, []);

    return response;
  }

  async exportWarranties(data) {
    const response = await this.api.get(
      `/dashboard/individual-customer-products/export/count-by-specific-time?interval=${data.interval}&temporalUnitEnum=${data.temporalUnitEnum}`,
      {
        responseType: "blob",
      },
    );

    return response;
  }
}

export default new StatsService();
